import { gql } from '@apollo/client';

import { SUGGEST_CHANGE_FIELDS } from './suggestChange.fragment';

export * from './suggestedChangeReview.mutation.generated';

export const SUGGESTED_CHANGE_REVIEW = gql`
  ${SUGGEST_CHANGE_FIELDS}
  mutation suggestedChangeReview($suggestedChangeId: ID!, $verdict: SuggestedChangeVerdictEnum!) {
    suggestedChangeReview(input: { suggestedChangeId: $suggestedChangeId, verdict: $verdict }) {
      success
      errors
    }
  }
`;
